var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"}),_c('div',{staticClass:"col-12 mt-2 d-flex justify-content-center text-center"},[_c('h1',[_vm._v("Página em manutenção")])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }